function tabsInit(parent) {
    var $links = $('.b-block-heading__menu-item', parent);
    var $tabs = $('.b-tab-parent__tab', parent);

    if($tabs.filter('.is-active').length === 0) {
        $tabs.eq(0).addClass('is-active');
        $links.eq(0).addClass('is-active');
        $(document).trigger('classGiven')
    }

    // Set corresponding tabs indexes
    for(var i = 0; i < $links.length; i++) {
        $links.eq(i).attr('data-index', i);
    }

    // Copy link-holders before corresponding tabs for mobile version

    parent.on('click', '.b-block-heading__menu-item', function () {
        var $this = $(this);
        var index = $this.attr('data-index');
        $links.removeClass('is-active');
        $tabs.removeClass('is-active');
        $this.addClass('is-active');
        $tabs.eq(index).addClass('is-active');
        $(document).trigger('classGiven');
        if($tabs.hasClass('slick-slider')) {
            $tabs.slick('setPosition');
        }

        return false;
    });
}
$(function () {
    $('.b-tab-parent').each(function () {
        tabsInit($(this));
    });
});
